var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWorkerOnSofa(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 184,
    height: 217.284,
    viewBox: "0 0 184 217.284",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22458",
    "data-name": "Group 22458",
    transform: "translate(-129.058 -318.021)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3570",
    "data-name": "Rectangle 3570",
    width: 92.814,
    height: 5.74,
    transform: "translate(130.684 352.011)",
    fill: "#bcc9e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3571",
    "data-name": "Rectangle 3571",
    width: 8.4,
    height: 33.989,
    transform: "translate(202.178 318.021)",
    fill: "#699dee",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3572",
    "data-name": "Rectangle 3572",
    width: 8.4,
    height: 33.989,
    transform: "translate(176.976 318.021)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3573",
    "data-name": "Rectangle 3573",
    width: 33.987,
    height: 8.4,
    transform: "translate(150.172 347.151) rotate(-54.674)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3574",
    "data-name": "Rectangle 3574",
    width: 8.4,
    height: 33.989,
    transform: "translate(193.777 318.021)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3575",
    "data-name": "Rectangle 3575",
    width: 8.4,
    height: 33.989,
    transform: "translate(185.376 318.021)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3576",
    "data-name": "Rectangle 3576",
    width: 6.349,
    height: 2.005,
    transform: "translate(203.201 324.168)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3577",
    "data-name": "Rectangle 3577",
    width: 6.349,
    height: 2.008,
    transform: "translate(178.004 347.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11843",
    "data-name": "Path 11843",
    d: "M226.615,268.947l5.184,3.671-1.161,1.635-5.185-3.671Z",
    transform: "translate(-72.741 74.762)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3578",
    "data-name": "Rectangle 3578",
    width: 6.346,
    height: 2.005,
    transform: "translate(194.803 324.168)",
    fill: "#becdf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3579",
    "data-name": "Rectangle 3579",
    width: 6.349,
    height: 2.008,
    transform: "translate(186.404 347.057)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3580",
    "data-name": "Rectangle 3580",
    width: 6.349,
    height: 2.005,
    transform: "translate(203.201 320.155)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3581",
    "data-name": "Rectangle 3581",
    width: 6.349,
    height: 2.008,
    transform: "translate(178.004 343.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3582",
    "data-name": "Rectangle 3582",
    width: 2.009,
    height: 6.348,
    transform: "translate(155.034 342.07) rotate(-54.667)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3583",
    "data-name": "Rectangle 3583",
    width: 6.346,
    height: 2.005,
    transform: "translate(194.803 320.155)",
    fill: "#becdf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3584",
    "data-name": "Rectangle 3584",
    width: 6.349,
    height: 2.008,
    transform: "translate(186.404 343.043)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3585",
    "data-name": "Rectangle 3585",
    width: 92.814,
    height: 5.74,
    transform: "translate(130.684 400.389)",
    fill: "#bcc9e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3586",
    "data-name": "Rectangle 3586",
    width: 8.4,
    height: 33.989,
    transform: "translate(202.178 366.402)",
    fill: "#bcc9e7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3587",
    "data-name": "Rectangle 3587",
    width: 8.4,
    height: 33.989,
    transform: "translate(176.976 366.402)",
    fill: "#699dee",
    opacity: 0.45
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11844",
    "data-name": "Path 11844",
    d: "M270.912,367.83l8.4-.022-.079-33.986-8.4.018Z",
    transform: "translate(-102.254 32.569)",
    fill: "#d2e4fd",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3588",
    "data-name": "Rectangle 3588",
    width: 8.4,
    height: 33.989,
    transform: "translate(193.777 366.402)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3589",
    "data-name": "Rectangle 3589",
    width: 8.4,
    height: 33.989,
    transform: "translate(185.376 366.402)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3590",
    "data-name": "Rectangle 3590",
    width: 6.349,
    height: 2.005,
    transform: "translate(203.201 372.549)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3591",
    "data-name": "Rectangle 3591",
    width: 6.349,
    height: 2.008,
    transform: "translate(178.004 369.344)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11845",
    "data-name": "Path 11845",
    d: "M273.788,344.3l6.349-.015,0-2.005-6.352.015Z",
    transform: "translate(-104.171 27.071)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3592",
    "data-name": "Rectangle 3592",
    width: 6.346,
    height: 2.005,
    transform: "translate(194.803 372.549)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3593",
    "data-name": "Rectangle 3593",
    width: 6.349,
    height: 2.008,
    transform: "translate(186.404 369.344)",
    fill: "#becdf1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3594",
    "data-name": "Rectangle 3594",
    width: 6.349,
    height: 2.005,
    transform: "translate(203.201 368.535)",
    fill: "#d2e4fd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3595",
    "data-name": "Rectangle 3595",
    width: 6.349,
    height: 2.008,
    transform: "translate(178.004 373.357)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11846",
    "data-name": "Path 11846",
    d: "M273.818,355.776l6.349-.012-.006-2.008-6.346.015Z",
    transform: "translate(-104.194 19.606)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3596",
    "data-name": "Rectangle 3596",
    width: 6.346,
    height: 2.005,
    transform: "translate(194.803 368.535)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3597",
    "data-name": "Rectangle 3597",
    width: 6.349,
    height: 2.008,
    transform: "translate(186.404 373.357)",
    fill: "#becdf1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11847",
    "data-name": "Path 11847",
    d: "M295.99,530.262h111.5c.657,0,1.193.3,1.193.672v5.548c0,.37-.535.672-1.193.672H295.99c-.655,0-1.192-.3-1.192-.672v-5.548c0-.37.537-.672,1.192-.672",
    transform: "translate(-117.841 -95.182)",
    fill: "#bcc9e7",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11848",
    "data-name": "Path 11848",
    d: "M268.424,781.04c-47.693,0-86.349,2.807-86.349,6.27s38.657,6.269,86.349,6.269,86.345-2.805,86.345-6.269-38.659-6.27-86.345-6.27",
    transform: "translate(-44.531 -258.273)",
    fill: "#d6daf9",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11849",
    "data-name": "Path 11849",
    d: "M471.037,653.51q14.388-15.983,15.173-51.076,6.594,1.334,9.818-.293,6.062,30.931-17.195,61.105H396.872V653.51Z",
    transform: "translate(-184.223 -141.93)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11850",
    "data-name": "Path 11850",
    d: "M184.055,653.51q-14.388-15.983-15.174-51.076-6.594,1.334-9.819-.293-6.057,30.931,17.2,61.105h81.959V653.51Z",
    transform: "translate(-28.752 -141.93)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11851",
    "data-name": "Path 11851",
    d: "M478.834,776.9a10.743,10.743,0,0,1-6.232,5.6h-75.73v-5.6Z",
    transform: "translate(-184.223 -255.581)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11852",
    "data-name": "Path 11852",
    d: "M210.576,776.9a10.738,10.738,0,0,0,6.233,5.6h75.726v-5.6Z",
    transform: "translate(-63.066 -255.581)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11853",
    "data-name": "Path 11853",
    d: "M589.121,593.008a30.073,30.073,0,0,1,17.65,3.372q-.788,35.095-15.174,51.075,5.217-9.913,1.864-14.455c3.742-11.075.51-16.217-11.209-17.445q4.91-8.149,6.869-22.548",
    transform: "translate(-304.782 -135.875)",
    fill: "#dadada",
    fillRule: "evenodd",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11854",
    "data-name": "Path 11854",
    d: "M207.122,593.008a30.077,30.077,0,0,0-17.65,3.372q.788,35.095,15.174,51.075-5.213-9.913-1.864-14.455c-3.742-11.075-.508-16.217,11.212-17.445q-4.91-8.149-6.872-22.548",
    transform: "translate(-49.342 -135.875)",
    fill: "#dadada",
    fillRule: "evenodd",
    opacity: 0.14
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11855",
    "data-name": "Path 11855",
    d: "M611.127,586.533q15.42-.675,18.237,5.414-3.218,1.627-9.818.293a30.076,30.076,0,0,0-17.65-3.372q2.687-2.31,9.231-2.335",
    transform: "translate(-317.558 -131.735)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11856",
    "data-name": "Path 11856",
    d: "M179.627,586.533q-15.415-.675-18.237,5.414,3.224,1.627,9.819.293a30.08,30.08,0,0,1,17.65-3.372q-2.687-2.31-9.231-2.335",
    transform: "translate(-31.08 -131.735)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11857",
    "data-name": "Path 11857",
    d: "M396.872,708.219H472.9v-.507q3.347,4.539-1.864,14.455H396.872Z",
    transform: "translate(-184.223 -210.587)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11858",
    "data-name": "Path 11858",
    d: "M301.128,708.219H225.1v-.507q-3.348,4.539,1.864,14.455h74.164Z",
    transform: "translate(-71.661 -210.587)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11859",
    "data-name": "Path 11859",
    d: "M396.872,657.821h64.82c11.719,1.228,14.951,6.37,11.209,17.445v.507H396.872Z",
    transform: "translate(-184.223 -178.141)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11860",
    "data-name": "Path 11860",
    d: "M300.816,657.821H236c-11.72,1.228-14.954,6.37-11.212,17.445v.507h76.029Z",
    transform: "translate(-71.348 -178.141)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11861",
    "data-name": "Path 11861",
    d: "M460.557,518.773q19.528,4.461,20.316,21.93c-.984,0-2.008.022-3.081.068a18.667,18.667,0,0,0-7.5,1.256,22.063,22.063,0,0,0-9.987-16.846q-12.866-6.411-63.435-2.7v-5.141q41.945-3.063,63.686,1.434",
    transform: "translate(-184.223 -85.972)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11862",
    "data-name": "Path 11862",
    d: "M225.062,518.773q-19.524,4.461-20.31,21.93c.978,0,2,.022,3.075.068a18.7,18.7,0,0,1,7.5,1.256,22.053,22.053,0,0,1,9.986-16.846q12.862-6.411,63.432-2.7v-5.141q-41.945-3.063-63.685,1.434",
    transform: "translate(-59.279 -85.972)",
    fill: "#becdf1",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11863",
    "data-name": "Path 11863",
    d: "M460.307,534.519a22.061,22.061,0,0,1,9.987,16.846,7.093,7.093,0,0,0-1.733,1.079q-1.963,14.4-6.868,22.548h-64.82V531.819q50.567-3.713,63.435,2.7",
    transform: "translate(-184.223 -95.312)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11864",
    "data-name": "Path 11864",
    d: "M244.987,534.519A22.054,22.054,0,0,0,235,551.365a7.09,7.09,0,0,1,1.73,1.079q1.962,14.4,6.872,22.548h64.816V531.819q-50.565-3.713-63.432,2.7",
    transform: "translate(-78.951 -95.312)",
    fill: "#d0d9ee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11865",
    "data-name": "Path 11865",
    d: "M561.724,526.264q-10.165,1.932-25.5,7.923a13.562,13.562,0,0,1,1.956.67q21.175-7.691,28.065-7.727a11.788,11.788,0,0,0-2.442-.575,179.245,179.245,0,0,1,1.167-19.961q-2.608,13.472-3.246,19.67",
    transform: "translate(-274.849 -79.792)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11866",
    "data-name": "Path 11866",
    d: "M520.674,584.431a10.417,10.417,0,0,0-8.36.628l2.042,7.085a1,1,0,0,1-1.018,1.4l1.889.079a7.423,7.423,0,0,1,2.635-.9q2.582,1.642,6.787-.716a8.693,8.693,0,0,0-2.134-6.859c.037-.013.079-.028.116-.04a14.329,14.329,0,0,0-1.956-.673",
    transform: "translate(-259.3 -130.037)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11867",
    "data-name": "Path 11867",
    d: "M549.476,606.449q.656-3.824,1.278-8.207a197.722,197.722,0,0,1-20.771,3.961c.037-.285.064-.565.083-.844q-4.2,2.357-6.787.716a7.422,7.422,0,0,0-2.635.9l19.1.8a4.23,4.23,0,0,1-1.663,2.873,88.876,88.876,0,0,0,11.4-.2",
    transform: "translate(-264.717 -139.393)",
    fill: "#406fb5",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11868",
    "data-name": "Path 11868",
    d: "M507.612,517.837a9.71,9.71,0,0,1,6.061-1.116c3.656-7.89,1.394-19.109,6.542-36.23q-5.563,2.792-12.96,27.019a19.808,19.808,0,0,1-2.171,1.544Z",
    transform: "translate(-254.598 -62.816)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11869",
    "data-name": "Path 11869",
    d: "M536.191,475.2c-5.147,17.121-2.886,28.34-6.542,36.23a13.78,13.78,0,0,1,2.3.491q15.334-5.991,25.5-7.923.642-6.2,3.246-19.67a179.239,179.239,0,0,0-1.167,19.961,11.8,11.8,0,0,1,2.442.575q-6.891.04-28.065,7.728l-.116.04a8.689,8.689,0,0,1,2.134,6.859c-.019.279-.046.559-.086.844a197.758,197.758,0,0,0,20.774-3.961,43.472,43.472,0,0,0,9.886-3.592q8.643-14.388,2.693-37.156-3.215-4.1-14.361-3.059-11.624,9.807-10.635.945a18.3,18.3,0,0,0-8,1.69",
    transform: "translate(-270.573 -57.521)",
    fill: "#699dee",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11870",
    "data-name": "Path 11870",
    d: "M523.218,480.62c-4.594,9.521-5.389,28.866-7.5,30.956q-1.2,1.44-5.648,3.533l.055.19.73,2.538a9.709,9.709,0,0,1,6.061-1.116c3.656-7.89,1.395-19.108,6.542-36.23-.08.04-.159.083-.239.129",
    transform: "translate(-257.838 -62.816)",
    fill: "#4a75cb",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11871",
    "data-name": "Path 11871",
    d: "M426.112,611.639l46.115,1.924a3.879,3.879,0,0,0,4.267-3.538l-51.917-2.164-.141-.006c-.5-.018-1.238.2-1,1.6a2.919,2.919,0,0,0,2.678,2.185",
    transform: "translate(-201.468 -145.646)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11872",
    "data-name": "Path 11872",
    d: "M407.566,537.018l29.8,1.241a2.193,2.193,0,0,1,1.858,1.519l6.313,21.9a1.008,1.008,0,0,1-1.018,1.4l-29.8-1.245a2.186,2.186,0,0,1-1.858-1.516l-6.31-21.908a1,1,0,0,1,1.015-1.4",
    transform: "translate(-190.479 -99.577)",
    fill: "#8d9fca",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11874",
    "data-name": "Path 11874",
    d: "M340.069,592.38a31.348,31.348,0,0,0,5.276-4.12q2.9,1.3,5.523,2.363,6.346-.821,14.863-1.577l-11.843-.493a2.921,2.921,0,0,1-2.678-2.185c-.235-1.4.5-1.617,1-1.6l.141.006,1.13.046a2.19,2.19,0,0,1-1.858-1.52l-3.122-10.827q-2.852-.16-5.059-.1c-8.36,3.032-15.565,15.455-31.112,25.8.257,2.714,1.6,4.441,3.671,6.168a218.926,218.926,0,0,0,21.174-10.188q1.564-.908,2.889-1.774",
    transform: "translate(-129.244 -122.558)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11875",
    "data-name": "Path 11875",
    d: "M260.93,641.825c6.184,5.454,10.769,8.748,13.48,10,2.922,1.353,3.754.325,4.466-3.081-8.152-2.592-3.72-4.38-6.774-6.425q-4.911-.3-11.173-4.585c-2.617-.272-2.919,1.336,0,4.09",
    transform: "translate(-94.464 -165.058)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11876",
    "data-name": "Path 11876",
    d: "M269.246,621.99c.263,1.9.44,2.821.681,4.483v0l.125.074.062.033.067.04.122.067.006.007.123.07.055.031.073.04.113.064.009.006.129.07.049.026.324.177.043.021.082.043.1.052.022.016.125.061.034.019.088.046.092.046.031.015.122.06.03.016.092.045.086.043.037.016.122.058.024.012.1.046.08.037.04.022.119.055.018.006.1.049.074.033.165.074.012,0,.177.079.052.021.12.049,0,0,.113.045.061.027.058.022.116.049h0l.116.046.055.022.061.024.11.043.009,0,.115.044.049.017.071.025.1.04.012,0,.113.043.043.016.073.024.1.034.021.006.113.039.036.013.08.024.116.036.11.038.031.009.085.027.086.025.027.008.113.034.024.006.089.024.076.022.037.012.111.03.021.006.092.021.071.022.043.01.11.026.22.052.113.028h.009l.1.023.058.013.049.013.11.02h0l.107.022.107.022h0l.1.018h.006l.107.022.046.006.061.012a3.845,3.845,0,0,0-.128-.667,18.983,18.983,0,0,1-5.734-9.641c-1.81-1.911-2.761-1.134-2.342,2.856m1.51,9.8a32.8,32.8,0,0,0,1.632,6.318c1.22,2.672,3.487,1.3,5.967-.565a79.757,79.757,0,0,1-7.6-5.752",
    transform: "translate(-101.158 -152.333)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11877",
    "data-name": "Path 11877",
    d: "M276.583,628.718l.077.028.015,0,.113.043.043.016.073.024.1.034.021.006.113.039.036.013.08.024.116.036.11.037.031.009.085.027.086.025.028.008.113.034.024.006.089.024.076.025.037.009.111.031.021.006.092.021.074.022.04.01.11.027.22.055.11.025h.012l.1.024.061.013.049.012.11.021h0l.107.022.107.022h0l.1.017.006,0,.107.018.046.006.061.013a3.848,3.848,0,0,0-.128-.667,18.984,18.984,0,0,1-5.734-9.641,3.527,3.527,0,0,0-1.232-.935,17.883,17.883,0,0,0,3.983,10.4",
    transform: "translate(-103.405 -152.447)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11878",
    "data-name": "Path 11878",
    d: "M304.423,655.922a7.926,7.926,0,0,1,2.439-2.253,8.4,8.4,0,0,1-2.812-4.525,12.4,12.4,0,0,1-4.7,1.48c1.088,1.638-.948,3.21,5.071,5.3",
    transform: "translate(-120.803 -172.497)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11879",
    "data-name": "Path 11879",
    d: "M400.183,638.11c9.95-.627,14-8.07,13.814-17.377a90.712,90.712,0,0,1-10.4.125,4.2,4.2,0,0,1-2.605.661l-34.276-1.431q-8.515.756-14.859,1.577-3.906.505-6.994,1.033a57.392,57.392,0,0,0-6.591,2.439l-.1.058A218.917,218.917,0,0,1,317,635.384c-.245-.2-.479-.406-.7-.611a7.94,7.94,0,0,0-2.439,2.253c.251.086.514.174.792.263-.009.058-.021.116-.034.174,23.232,2.107,30.883-1.424,37.043-3.283,20.169,3.6,29.877,4.922,48.527,3.931",
    transform: "translate(-130.234 -153.601)",
    fill: "#040227",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11880",
    "data-name": "Path 11880",
    d: "M565.69,422.763c-.758-3.142-.9-6.716-1.938-8.095-8.382-2.95-9.318,1.687-13.013,2.574a7.889,7.889,0,0,0,1.054,3.857q-.422,7.618,3.576,9.409a5.025,5.025,0,0,0,3.326,1.25c-.146.648-.6,3-.789,3.6v0q-.99,8.862,10.635-.945l.034,0c-.049-2.082-.223-3.677-.19-5.242q.037-1.6.129-2.843,4.164-4.338,1.644-7.028-3.292-1.56-3.821,4.429c-.654-.254-.2-.036-.648-.969",
    transform: "translate(-284.286 -19.378)",
    fill: "#ffb27d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11881",
    "data-name": "Path 11881",
    d: "M539.608,399.732c3.695-.886,4.631-5.524,13.013-2.577,1.033,1.382,1.179,4.955,1.941,8.1.446.932-.009.715.645.969q.528-5.988,3.821-4.428,2.517,2.69-1.644,7.027-.092,1.242-.129,2.843c7.807-7.2,6.231-16.966,1.473-20.176a8.061,8.061,0,0,1,3.54,1.345,6.219,6.219,0,0,0-6.994-2.418,5.561,5.561,0,0,0-.18-3.64,7.765,7.765,0,0,1-.663,2.571c-1.883-1.718-5.5-2.119-9.195-.728-4.787,1.8-9.733,6.2-11.616,4.891.281,4.517,2.849,7.259,5.989,6.223",
    transform: "translate(-273.155 -1.867)",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11882",
    "data-name": "Path 11882",
    d: "M577.641,461.284a9.41,9.41,0,0,1-4.937,1.421c-.08.358-.257,1.244-.428,2.064a9.155,9.155,0,0,0,5.365-3.485",
    transform: "translate(-298.294 -50.325)",
    fill: "#ed985f",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11883",
    "data-name": "Path 11883",
    d: "M355.932,603.08a28.667,28.667,0,0,1-6.759-3.33q-1.32,1.28-2.629,2.5c-8.54,7.962-16.794,14.052-24.714,17.8-.785.369-1.565.718-2.344,1.045.153.15.306.3.471.446l.7.608c1.611-.687,3.222-1.39,4.809-2.1,6.456-2.884,12.5-5.833,16.366-8.085.036-.019.068-.041.1-.058q1.5-.881,2.785-1.715c.651-.422,1.256-.837,1.824-1.241a26.613,26.613,0,0,0,3.451-2.88q2.9,1.3,5.523,2.363,3.578-.463,7.844-.9,3.3-.34,7.019-.672l-7.019-.29-4.824-.2a2.92,2.92,0,0,1-2.678-2.185,1.882,1.882,0,0,1,.07-1.1",
    transform: "translate(-133.897 -140.374)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11884",
    "data-name": "Path 11884",
    d: "M398.762,634.482q-8.7,2.442-24.186.6-2.65-.3-5.117-.6-5.292-.657-9.758-1.333-4.443-.675-8.064-1.372a31.611,31.611,0,0,1-6.089,2.706c-.85.284-1.742.546-2.666.794q-10.875,2.895-28.538,2.339c-.168.193-.33.4-.489.611.251.086.514.174.791.263l-.033.174c14.129,1.28,22.5.477,28.269-.768,3.717-.8,6.359-1.787,8.773-2.519,2.876.517,5.539.985,8.045,1.4,15.076,2.53,24.495,3.38,40.481,2.53,4.454-.28,7.728-1.929,9.968-4.5,2.764-3.166,3.949-7.74,3.846-12.881-.447.033-.9.061-1.351.085q-1.366.078-2.776.111-.49,9.367-11.109,12.353",
    transform: "translate(-130.234 -154.801)",
    fill: "#142d4d",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11885",
    "data-name": "Path 11885",
    d: "M458.412,569.846a2.463,2.463,0,0,1,2.341,2.014,1.667,1.667,0,0,1-1.687,2.014,2.465,2.465,0,0,1-2.341-2.014,1.669,1.669,0,0,1,1.687-2.014",
    transform: "translate(-223.129 -120.926)",
    fill: "#fff",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkerOnSofa);
export default __webpack_public_path__ + "static/media/worker-on-sofa.51c3d3893b7b6a25e1acd07022df11bf.svg";
export { ForwardRef as ReactComponent };